import * as types from '../types/authTypes';

const loadUser = () => {
  try {
    if (typeof window === 'undefined') {
      return { token: null, user: null, isAuthenticated: false };
    }
    const token = window.localStorage.getItem('CiteMatchToken');
    const userJson = window.localStorage.getItem('CiteMatchUser');
    return {
      token,
      user: userJson ? JSON.parse(userJson) : null,
      isAuthenticated: !!token,
    };
  } catch (_) {
    return { token: null, user: null, isAuthenticated: false };
  }
};

const initialState = {
  ...loadUser(),
  loading: false,
  error: null,
  forgotLoading: false,
  forgotMessage: '',
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.AUTH_REQUEST:
      return { ...state, loading: true, error: null };
    case types.AUTH_SUCCESS:
      return {
        ...state,
        loading: false,
        token: action.payload.token,
        user: action.payload.user,
        isAuthenticated: true,
        error: null,
      };
    case types.AUTH_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case types.AUTH_LOGOUT:
      return {
        token: null,
        user: null,
        isAuthenticated: false,
        loading: false,
        error: null,
        forgotLoading: false,
        forgotMessage: '',
      };
    case types.FORGOT_PASSWORD_REQUEST:
      return { ...state, forgotLoading: true, forgotMessage: '', error: null };
    case types.FORGOT_PASSWORD_SUCCESS:
      return { ...state, forgotLoading: false, forgotMessage: action.payload, error: null };
    case types.FORGOT_PASSWORD_FAILURE:
      return { ...state, forgotLoading: false, error: action.payload };
    default:
      return state;
  }
};

export default authReducer;

